import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";

import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import { useFormik, FormikProvider } from "formik";

import {  Apitoken, Authtoken } from "../Global";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import $ from "jquery";
const BankAccountTransactionAdd = () => {

    let season_id = localStorage.getItem("season_id");

  const [menu, setMenu] = useState(false);
  const [backendErrors, setBackendErrors] = useState([]);
  const [permission, setPermission] = useState({});

  const [typeLists, setTypeLists] = useState([]);
  const [bankLists, setBankLists] = useState([]);
  
 const primaryCurrency =  [
    {
        "label": "EUR",
        "value": 1,
        "symbol": "€",
        "key": "cabrane-0"
    },
    {
        "label": "USD",
        "value": 2,
        "symbol": "$",
        "key": "cabrane-1"
    },
    {
        "label": "GBP",
        "value": 3,
        "symbol": "£",
        "key": "cabrane-2"
    },
    {
        "label": "MAD ",
        "value": 4,
        "symbol": "dh",
        "key": "cabrane-3"
    }
];

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const defaultDate= (formatDate(new Date()));


  
  const transacionList = ([
    { value: 'DEBIT', label: "DEBIT" },
    { value: 'CREDIT', label: "CREDIT" },
  ]);
  
  const formik = useFormik({
    initialValues: {
      bank: "",
      season_id:season_id,
      transaction_date: defaultDate,
      expense_type: "",
      transaction_amount: "",
      transaction_type:"",
      currency:"4",
      note:'',
      paid_to:''
   
    },
    onSubmit: (values,{ setSubmitting }) => {
      //alert(JSON.stringify(values, null, 2));
      axios
        .post("/bank-account-transactions/add", values, {
          headers: {
             Authorization: `Bearer ${Authtoken}`,
             Apitoken: Apitoken,
             "Content-Type": "multipart/form-data",
            },
        })
        .then((response) => {
          
          delete backendErrors['error'];
          setSubmitting(false);
         // actions.setSubmitting(false);
         $("#form-submit").text("Add Transaction");
          if (response.data.code === 200) {
           
            toast.success(response.data.message);
         //   actions.resetForm();
            setTimeout(() => {
              window.location.href = "/bank-account-transactions";
            }, 1000);
          }  else if (response.data.code === 422) {
              setBackendErrors(response.data.error);
          }
          else if (response.data.code === 401) {
            setBackendErrors(response.data.error);
          }
          else {
             setBackendErrors(response.data.error);
          }
        })
        .catch((error) => {
          toast.error(error);
        });
    },
  });


  useEffect(() => {
        setPermission(FindModuleById(446)); 
console.log(permission);


    axios
    .get(`/helper/banks-list2`, {
      headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
    }).then((response) => {
      if (response.data.code === 200) {
        let types = response.data.data.banks;
        let typeslisting = types.map((ord, index) => ({
          label: ord.title,
          value: ord.id,
          key: `location-${index}`,
        }));
        setBankLists(typeslisting);
      } else {
        console.log("API response is not an array");
      }
    }).catch((error) => {
      console.log(error);
    });


    axios
    .get(`/helpers/expenses-types`, {
      headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
    }).then((response) => {
      if (response.data.code === 200) {
        let types = response.data.data.types;
        let typeslisting = types.map((ord, index) => ({
          label: ord.title,
          value: ord.id,
          key: `location-${index}`,
        }));
        setTypeLists(typeslisting);
      } else {
        console.log("API response is not an array");
      }
    }).catch((error) => {
      console.log(error);
    });
 

  
}, []);

  const customHandleInput = (event) => {
    const Input_name = event.target.name;
    delete backendErrors[Input_name];
  };
  const customHandleStatus = (event) =>{
    const val = event.value;
    if(val =='CREDIT'){  
      $(".expense_type_hiv").hide();
    }else{
      $(".expense_type_hiv").show();
    }
}

const handleSelectChange = (name, selectedOption) => {
  const value = selectedOption ? selectedOption.value : "";
  updateFormikValue(name, value);
  customHandleInput({ target: { name, value } });
};

const updateFormikValue = (name, value) => {
  formik.setFieldValue(name, value);
};

  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />

        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Bank Account Transaction</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                    <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/bank-account-transactions">Expenses</Link>
                    </li>
                    <li className="breadcrumb-item active">Add Bank Account Transaction</li>
                  </ul>
                </div>
              </div>
            </div>
            {permission && permission.add == 1 && (
                    <FormikProvider value={formik}>
                      <form onSubmit={formik.handleSubmit}>
                     
                      <div className="row">
                        <div className="col-md-12">
                          <div className="card">
                              <div className="card-body">
                                <h4 className="card-title">Add Bank Account Transaction</h4>
                                  <div className="row">


                                  <div className="col-md-6">
                                    <div className="form-group status">
                                        <label>Bank</label>
                                        <Select
                                          className="w-100"
                                          value={bankLists.find(option => option.value == formik.values.bank) || null} // Ensure correct format
                                          name="bank"
                                          //onChange={(selectedOption) => handleSelectChange("currency", selectedOption)}
                                          onChange={(selectedOption) => {
                                            handleSelectChange("bank", selectedOption);
                                            //customfunction(selectedOption);
                                          }}
                                          onBlur={formik.handleBlur}
                                          options={bankLists}
                                          placeholder="Select"  

                                       
                                        />
                                        <small>
                                          {backendErrors.bank && (
                                              <span className="form-error mt-1">
                                                {backendErrors.bank}
                                              </span>
                                            )}
                                        </small>
                                      </div>
                                    </div>

                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label>Transaction Date</label>
                                        <input
                                          type="date"
                                          name="transaction_date"
                                          value={formik.values.transaction_date}
                                          className="form-input form-control"
                                          onChange={(e) => {
                                            formik.handleChange(e);
                                            customHandleInput(e);
                                           // setDefaultDate(e.target.value)
                                          }}
                                          onBlur={formik.handleBlur}
                                         // defaultValue={defaultDate}

                                        />
                                        <small>
                                          {backendErrors.transaction_date && (
                                              <span className="form-error mt-1">
                                                {backendErrors.transaction_date}
                                              </span>
                                            )}
                                        </small>
                                      </div>
                                    </div>

                                    <div className="col-md-6 ">
                                    <div className="form-group ">
                                        <label>Paid To</label>
                                        <input
                                          type="text"
                                          name="paid_to"
                                          value={formik.values.paid_to}
                                          className="form-input form-control"
                                          onChange={(e) => {
                                            formik.handleChange(e);
                                            customHandleInput(e);
                                          }}
                                          onBlur={formik.handleBlur}
                                        />
                                        <small>
                                          {backendErrors.paid_to && (
                                              <span className="form-error mt-1">
                                                {backendErrors.paid_to}
                                              </span>
                                            )}
                                        </small>
                                      </div>
                                    </div>
                                    <div className="col-md-6">
                                      <div className="form-group status2">
                                        <label>Select Currency</label>
                                        <Select
                                          className="w-100"
                                          value={primaryCurrency.find(option => option.value == formik.values.currency) || null} // Ensure correct format
                                          name="currency"
                                          //onChange={(selectedOption) => handleSelectChange("currency", selectedOption)}
                                          onChange={(selectedOption) => {
                                            handleSelectChange("currency", selectedOption);
                                            //customFuction(selectedOption);
                                          }}
                                          onBlur={formik.handleBlur}
                                          options={primaryCurrency}
                                          placeholder="Select"  

                                       
                                        />


                                      
                                        <small>
                                          {backendErrors.currency && (
                                              <span className="form-error mt-1">
                                                {backendErrors.currency}
                                              </span>
                                            )}
                                        </small>
                                        </div>
                                      
                                      </div>
                                    <div className="col-md-6">
                                    <div className="form-group">
                                        <label>Transaction Amount</label>
                                        <input
                                           type="text"
                                           onKeyPress={(event) => {
                                             // Allow only numbers (0-9)
                                             if (!/^[0-9.]$/.test(event.key) || (event.key === '.' && event.target.value.includes('.'))) {
                                              event.preventDefault();
                                            }
                                           }}
                                          name="transaction_amount"
                                          value={formik.values.transaction_amount}
                                          className="form-input form-control"
                                          onChange={(e) => {
                                            formik.handleChange(e);
                                            customHandleInput(e);
                                          }}
                                          onBlur={formik.handleBlur}
                                        />
                                        <small>
                                          {backendErrors.transaction_amount && (
                                              <span className="form-error mt-1">
                                                {backendErrors.transaction_amount}
                                              </span>
                                            )}
                                        </small>
                                      </div>
                                    </div>
                                    <div className="col-md-6">
                                    <div className="form-group status">
                                        <label>Transaction Type</label>
                                        <Select
                                           className="w-100"
                                           value={transacionList.find(option => option.value == formik.values.transaction_type) || null} // Ensure correct format
                                           name="transaction_type"
                                           //onChange={(selectedOption) => handleSelectChange("currency", selectedOption)}
                                           onChange={(selectedOption) => {
                                             handleSelectChange("transaction_type", selectedOption);
                                             customHandleStatus(selectedOption);
                                            // customHandleStatus(e);
                                           }}
                                           onBlur={formik.handleBlur}
                                           options={transacionList}
                                           placeholder="Select"  

                                          // value={formik.values.transaction_type}
                                          // name="transaction_type"
                                          // data={transacionList}
                                          // className= "w-100"
                                          // onChange={(e) => {
                                          //   formik.handleChange(e);
                                          //   customHandleInput(e);
                                          //   customHandleStatus(e);

                                          // }}
                                          //   onBlur={formik.handleBlur}
                                          // options={{
                                          //   placeholder: "Select Type",
                                          // }}
                                        />
                                        <small>
                                          {backendErrors.transaction_type && (
                                              <span className="form-error mt-1">
                                                {backendErrors.transaction_type}
                                              </span>
                                            )}
                                        </small>
                                      </div>
                                    </div>
                                
                                     <div className="col-md-6 expense_type_hiv">
                                    <div className="form-group status">
                                        <label>Expense Type</label>
                                        <Select
                                         className="w-100"
                                         value={typeLists.find(option => option.value == formik.values.expense_type) || null} // Ensure correct format
                                         name="expense_type"
                                         //onChange={(selectedOption) => handleSelectChange("currency", selectedOption)}
                                         onChange={(selectedOption) => {
                                           handleSelectChange("expense_type", selectedOption);
                                           //customfunction(selectedOption);
                                         }}
                                         onBlur={formik.handleBlur}
                                         options={typeLists}
                                         placeholder="Select" 

                                        />
                                        <small>
                                          {backendErrors.expense_type && (
                                              <span className="form-error mt-1">
                                                {backendErrors.expense_type}
                                              </span>
                                            )}
                                        </small>
                                      </div>
                                    </div>
                                    
                                    <div className="col-md-12 ">
                                    <div className="form-group ">
                                        <label>Note</label>
                                        <input
                                          type="text"
                                          name="note"
                                          value={formik.values.note}
                                          className="form-input form-control"
                                          onChange={(e) => {
                                            formik.handleChange(e);
                                            customHandleInput(e);
                                          }}
                                          onBlur={formik.handleBlur}
                                        />
                                        <small>
                                          {backendErrors.note && (
                                              <span className="form-error mt-1">
                                                {backendErrors.note}
                                              </span>
                                            )}
                                        </small>
                                      </div>
                                    </div>
                                   

                                  
                                
                                  

                                  </div>

                              </div>
                          </div>
                        </div>
                      </div>
                     
                      <div className="row">
                        <div className="col-md-12">
                          <div className="card">
                              <div className="card-body">
                                <div className="text-end mt-4">
                                  <button className="btn btn-primary" type="submit" id="form-submit"  disabled={formik.isSubmitting}>
                                    Add Transaction
                                  </button>
                              </div>
                              </div>
                          </div>
                        </div>
                      </div>
                                
                        
                      </form>
                    </FormikProvider>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
export default BankAccountTransactionAdd;
